import { createApp } from "vue";
import App from "@/App.vue";
import router from "@/utils/router";
import MasonryWall from '@yeger/vue-masonry-wall';
import VueKinesis from "vue-kinesis";

const app = createApp(App);

app.use(router);
app.use(MasonryWall);
app.use(VueKinesis);
app.mount("#app");
